import React, {useState} from 'react';

import './Button.css'
import OverlayMenu from './OverlayMenu'

const Button = (props) => {
  // Property value
  const { name, value, index, id } = props
  // Property functions
  const { menuOnShow, menuOnHide, updateComponent } = props

  const onUpdate = (updatedName, updatedValue) => {
    updateComponent({
      [updatedName]: updatedValue,
    })
  }

  const onShow = (e) => {
    menuOnShow()
  }

  const onHide = (e) => {
    menuOnHide()
  }

  return (
    // <div>
      <OverlayMenu 
        id={id} 
        name={name} 
        value={value} 
        onUpdate={onUpdate}
        onShow={onShow} onHide={onHide}>
        <button className="button-component">
          {name === "" ? "이름 없음" : name}
        </button>
      </OverlayMenu>
    // </div>
  )
}

export default Button